import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-form-tags',
  templateUrl: './form-tags.component.html',
  styleUrls: ['./form-tags.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormTagsComponent implements OnInit, OnDestroy {
  @Input()
  form: FormGroup;
  @Input()
  field;
  @Input()
  product;
  @Output()
  edit = new EventEmitter();

  _alive = true;
  _paramChange$ = new Subject<any>();
  _firstChange = true;

  get label() {
    return this.field && this.field.label;
  }

  get fieldName() {
    return this.field && this.field.fieldName;
  }

  get disabled() {
    return this.field && this.field.disabled;
  }

  constructor() {}

  ngOnInit() {
    this._paramChange$
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        takeWhile(() => this._alive)
      )
      .subscribe(change => this.edit.emit(change));
  }

  ngOnDestroy() {
    this._alive = false;
  }

  changedParam() {
    let value = this.form.get('tags').value;

    if (value) {
      value = value.map(t => (typeof t === 'string' ? t : t.value));
      this._paramChange$.next({ tags: value });
    }
  }
}
